// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G1wuq","delete":"styles_delete__272-w","update":"styles_update__2Ym1x","add":"styles_add__3R2Wz"};